import { flow, chunk, map, reverse } from '../../../lib/utilities';

const defaultOptions = {
    decimalDigits: 0,
    decimalSeparator: '.',
    thousandsSeparator: ',',
};

function formatNumber(number, options) {
    const actualOptions = { ...defaultOptions, ...options };

    const numberStrParts = number
        .toFixed(actualOptions.decimalDigits)
        .toString()
        .split('.');

    //TODO: verify implementation
    return flow(
        reverse,
        (x) => chunk(x, 3),
        (x) => map(x, reverse),
        reverse,
        (x) => map(x, (nums) => nums.join('')),
        (x) => x.join(actualOptions.thousandsSeparator),
        (num) => [num, ...numberStrParts.slice(1)],
        (x) => x.join(actualOptions.decimalSeparator)
    )(numberStrParts[0]);
}

export default formatNumber;
